import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../../../../components/Modal/CustomModal";
import { CustomTextField } from '../../../../../components/CustomTextField';
import {STATUS_MODEL} from '../../../../../enums/statusEnum';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ModalInput = (props) => {
    const { onClickFn, onHide, isReset, isAllReset, title = '', subtitle = '', resume, statusRequest } = props;
    const { t } = useTranslation();

    const [description, setDescription] = useState('');
    const [emptyFields, setEmptyFields] = useState(false);

    const handleOnConfirm = (e, description) => {
        if(( (description == '' || description == null) && statusRequest == STATUS_MODEL.DENIED )){
            setEmptyFields(true);
            return;
        }
        onClickFn(e, description);
        onHide();
        if (isReset) isReset([]);

        if (isAllReset) isAllReset(false);
    };

    const handleOnHide = (e) => {
        onHide();
        if (isReset) isReset([]);

        if (isAllReset) isAllReset(false);
    };

    return (
        <CustomModal
            title={t(title)}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onHide={(e) => {
                handleOnHide(e);
            }}
            onConfirm={(e) => {
                handleOnConfirm(e, description);
            }}
        >
            <div className="px-0 py-0">
                <p className='d-flex justify-content-center align-content-center flex-wrap-no-gap align-items-center text-center fs-14px ibl-font-w-400'>
                    {t(subtitle)}
                </p>
                <p className='d-flex justify-content-center align-content-center flex-wrap-no-gap align-items-center text-uppercase text-center fs-14px ibl-font-w-700'>
                    {t(resume)}
                </p>
                <div className='d-flex align-items-center mt-4'>
                    <CustomTextField
                        id='txt_mi_comment'
                        name='comment'
                        trans='comment'
                        type='text'
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value)
                        }}
                        multiline={true}
                        length={512}
                        emptyFields={emptyFields}
                        required={statusRequest == STATUS_MODEL.DENIED}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default ModalInput;
